<template>
  <div class="search-container container-xl px-3 px-xl-3 col-md-9 col-xl-12 mt-3 mt-lg-0">
    <div class="search-bar col-xl-11 mx-auto home-search-skeleton">
      <div
        class="search-bar-head d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-md-center gap-2"
      >
        <Skeleton width="180px" height="20px" />
        <div class="d-flex justify-content-between align-items-center w-100">
          <Skeleton width="140px" height="16px" />
          <Skeleton width="90px" height="16px" />
        </div>
      </div>

      <div class="search-bar-body row input-group m-0 g-3 justify-content-between">
        <div class="col-lg-6 col-xl-3 p-0 pt-lg-0 pb-lg-0">
          <Skeleton height="44px" class="w-100" borderRadius="12px" />
        </div>
        <div class="col-lg-6 col-xl-3 p-0 ps-lg-3 pt-3 pt-lg-0 pb-xl-0 pt-xl-0">
          <Skeleton height="44px" class="w-100" borderRadius="12px" />
        </div>
        <div class="col-xl-2 col-lg-6 col-sm-6 p-0 pe-sm-3 pe-lg-0 ps-xl-3 pt-3 pt-xl-0">
          <Skeleton height="44px" class="w-100" borderRadius="12px" />
        </div>
        <div class="col-xl-2 col-lg-3 col-sm-6 p-0 ps-lg-3 pt-3 pt-xl-0">
          <Skeleton height="44px" class="w-100" borderRadius="12px" />
        </div>
        <div class="col-lg-3 col-xl-2 pe-xl-0 p-0 ps-lg-3 pt-3 pt-xl-0">
          <Skeleton height="44px" class="w-100" borderRadius="12px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style scoped lang="scss">
.home-search-skeleton {
  pointer-events: none;
}
</style>
